var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-block-item"},[_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"right-slot"},[_vm._t("right")],2)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }